import { saveToken } from '../utils';
import { TOKEN_KEY, USER_KEY } from '../constants';

function getAuthUrlParams() {
  var token = null;
  var userId = null;
  var queryParams = new URLSearchParams(window.location.search);

  if (queryParams.has(TOKEN_KEY)) {
    token = queryParams.get(TOKEN_KEY);
    saveToken(token);
    queryParams.delete(TOKEN_KEY);
  }

  if (queryParams.has(USER_KEY)) {
    userId = queryParams.get(USER_KEY);
    queryParams.delete(USER_KEY);
  }

  if (token || userId) {
    window.history.replaceState({}, '', queryParams.toString() !== '' ? "".concat(window.location.pathname, "?").concat(queryParams) : window.location.pathname);
  }

  return {
    token: token,
    userId: userId
  };
}

export default getAuthUrlParams;